// Constants
export const info_garantia = () => {
  return {
    info_garantia: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        name: 'pacId',
        readonly: true,
        type: 'number',
        dataform: ['paciente_pacientes','paciente_garantias','orden_garantias','orden_pendgarantias'],
        datatype: {
          predeterminate: ''
        }
      },
      id_info_orden: {
        type: 'text',
        label: 'Proveedor lente',
        dataform: ['paciente_pacientes','paciente_garantias','orden_garantias','orden_pendgarantias'],
        readonly: true,
        description: 'examen',
        validate: '',
        datatype: { 
          type: 'select', 
          predeterminate: '1',
          list: 'datos_proveedores_lente',
          label: 'name'
        }
      },
      id_datos_pacientes: {
        type: 'text',
        label: 'Paciente',
        dataform: ['paciente_pacientes','paciente_garantias','orden_garantias','orden_pendgarantias'],
        readonly: true,
        description: 'paciente',
        validate: '',
        datatype: { 
          disabled: true,
          type: 'select', 
          predeterminate: '',
          list: 'datos_pacientes',
          label: 'name'
        }
      },     
      garantia: {
        type: 'text',
        label: 'Motivo garantía',
        dataform: ['paciente_pacientes','paciente_garantias','orden_garantias','orden_pendgarantias'],
        placeholder: '',
        description: 'garantia',
        validate: '',
        datatype: 
        {
          type: 'textarea',
          disabled: false,
          predeterminate: '',
        }
      }, 
      estado: {
        type: 'text',
        label: 'estado',
        dataform: ['paciente_pacientes','paciente_garantias','orden_garantias','orden_pendgarantias'],
        placeholder: '',
        description: 'garantia',
        validate: '',
        datatype: 
        {
          type: 'textarea',
          disabled: false,
          predeterminate: 'examen',
        }
      },     
    }
  }
}

export function asign_info_garantia(){
  var asign= Object.keys(info_garantia().info_garantia);
  var objeto = info_garantia().info_garantia
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

